import { render, staticRenderFns } from "./AudioPlayerComponent.vue?vue&type=template&id=37bd1562&"
import script from "./AudioPlayerComponent.vue?vue&type=script&lang=js&"
export * from "./AudioPlayerComponent.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlayerComponent.vue?vue&type=style&index=0&id=37bd1562&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports